import React from "react";

//MUI
import Button from "@mui/material/Button";
// CSS
import "./index.scss";

const MuiButtonContained = ({
  disabled = false,
  variant = "contained",
  style = {},
  type = "button",
  logo = null,
  endLogo = null,
  className = "",
  onClick = () => { },
  title = "",
}) => {
  const defaultClassStyle =
    variant === "contained" ? "oh-contained-button" : "oh-outlined-button";
  return (
    <Button
      disabled={disabled}
      sx={style}
      type={type}
      className={`oh-default-button ${defaultClassStyle} ${className}`}
      onClick={onClick}
    >
      {logo && <span className="oh-contained-start-logo">{logo}</span>}
      {title}
      {endLogo && <span className="oh-contained-start-logo">{endLogo}</span>}
    </Button>
  );
};

export default MuiButtonContained;
